import {
  EmptyButton,
  EmptyButtonSize,
} from "@smartsuite/react-ui/lib/components/buttons/EmptyButton/EmptyButton";
import {
  RoundButton,
  roundButtonStylesMedium,
} from "@smartsuite/react-ui/lib/components/buttons/RoundButton/RoundButton";
import { PlainTextField } from "@smartsuite/react-ui/lib/components/forms/PlainTextField/PlainTextField";
import { Modal } from "@smartsuite/react-ui/lib/components/modals/Modal/Modal";
import { ModalSizes } from "@smartsuite/react-ui/lib/components/modals/Modal/Modal.constants";
import { ModalDefaultContent } from "@smartsuite/react-ui/lib/components/modals/ModalDefaultContent/ModalDefaultContent";
import { ModalFooter } from "@smartsuite/react-ui/lib/components/modals/ModalFooter/ModalFooter";
import { ModalHeader } from "@smartsuite/react-ui/lib/components/modals/ModalHeader/ModalHeader";
import { ModalOverlay } from "@smartsuite/react-ui/lib/components/modals/ModalOverlay/ModalOverlay";
import { Icon } from "@smartsuite/react-ui/lib/components/utils/Icon/Icon";
import { useDependentState } from "@smartsuite/react-ui/lib/hooks/useDependentState";
import { useInputGroupState } from "@smartsuite/react-ui/lib/hooks/useInputGroupState/useInputGroupState";
import { Colors } from "@smartsuite/types";
import type React from "react";
import { useEffect, useRef } from "react";

import "./DuplicateDesignModal.sass";
import { DuplicateDesignModalIcon } from "./DuplicateDesignModalIcon";

interface DuplicateDesignModalProps {
  active: boolean;
  name: string;
  onCancel: () => void;
  onConfirm: (copyName: string) => void;
}

export const DuplicateDesignModal: React.FunctionComponent<
  DuplicateDesignModalProps
> = ({ active, name, onCancel, onConfirm }) => {
  const [copyName, setCopyName] = useDependentState(name);
  const inputRef = useRef<HTMLInputElement>(null);
  const { state, onBlur, onFocus } = useInputGroupState();

  useEffect(() => {
    if (active) {
      setTimeout(() => {
        inputRef.current?.focus();
        inputRef.current?.select();
      });
    }
  }, [active]);

  return (
    <ModalOverlay active={active} onClose={onCancel}>
      <Modal
        size={ModalSizes.S}
        header={
          <ModalHeader
            title="Duplicate Design"
            iconSize="M"
            iconName="layers"
          />
        }
        footer={
          <ModalFooter
            buttons={
              <>
                <div style={{ marginRight: "15px" }}>
                  <EmptyButton size={EmptyButtonSize.LG} onClick={onCancel}>
                    Cancel
                  </EmptyButton>
                </div>

                <RoundButton
                  styles={roundButtonStylesMedium}
                  disabled={!copyName}
                  onClick={() => onConfirm(copyName)}
                >
                  Duplicate
                </RoundButton>
              </>
            }
          />
        }
        onClose={onCancel}
      >
        <ModalDefaultContent>
          <div className="duplicate-design-modal">
            <div className="duplicate-design-modal__item-wrapper">
              <div className="duplicate-design-modal__item">
                <DuplicateDesignModalIcon label={name} />
              </div>

              <div className="duplicate-design-modal__item duplicate-design-modal__item--duplicate sh-2">
                <DuplicateDesignModalIcon label={copyName} />
              </div>

              <div className="duplicate-design-modal__arrow">
                <Icon name="arrow-right" size="M" color={Colors.dBlue} />
              </div>
            </div>

            <PlainTextField
              ref={inputRef}
              state={state}
              className="duplicate-design-modal__input"
              label="Name"
              placeholder="Enter name..."
              value={copyName}
              maxLength={50}
              onChangeValue={setCopyName}
              onBlur={onBlur}
              onFocus={onFocus}
            />
          </div>
        </ModalDefaultContent>
      </Modal>
    </ModalOverlay>
  );
};
